type EnvKey = keyof ImportMetaEnv

const trimUrl = (url = ''): string => url.trim().replace(/\/+$/, '')

const envValue = (key: EnvKey): string => {
  const runtimeValue = typeof window === 'undefined' ? '' : window.__FULFILLMENT_PANEL_ENV__?.[key]
  return runtimeValue?.trim() || import.meta.env[key]?.trim() || 'https://ff-api-stg.syncdrivetechnology.com'
}

const apiBaseUrl = () => trimUrl(envValue('VITE_API_GATEWAY_URL'))

export const authApiUrl = apiBaseUrl

export const challanApiUrl = apiBaseUrl
